import type { BuildingKind } from './types';

export const BUILDING_KIND_LABEL: Record<BuildingKind, string> = {
  CAMPUS: 'Campus building',
  WAREHOUSE: 'Warehouse (off campus)',
};

const pad = (value: number) => String(value).padStart(2, '0');

/** Today in the viewer's time zone, as YYYY-MM-DD. */
export function localToday(now = new Date()) {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Whether a building or room is in use on a day (YYYY-MM-DD); places without dates always are. */
export function isOpenOn(place: { openedOn?: string | null; closedOn?: string | null } | null | undefined, day = localToday()) {
  if (!place) return true;
  return (!place.openedOn || place.openedOn <= day) && (!place.closedOn || place.closedOn > day);
}

export const placeLabel = (parts: { cart?: string | null; room?: string | null; building?: string | null }) =>
  [parts.cart, parts.room, parts.building].filter(Boolean).join(' · ') || 'No location';
